<template>
  <v-data-table :items="selectedStudent" :headers="headers" disable-sort :items-per-page="5">
    <template v-slot:[`item.name`]="{ item }">
      <card-student-name :student="item" link />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      <span>{{ item.dob | ddmmyyyy }}</span>
    </template>
    <template v-slot:[`item.currentClass`]="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
        <span v-if="item.currentClass">{{ item.currentClass | getCurrentClass }}</span>
      </router-link>
    </template>
    <template v-slot:[`item.senderMethod`]="{ item }">
      <div class="d-flex align-center">
        {{ item | getNotificationMethod }}
        <div v-if="hasMobileToken(item)">
          <v-tooltip max-width="250px" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
                <v-icon color="success">mdi-check</v-icon>
              </div>
            </template>
            <span>Đã đăng nhập</span>
          </v-tooltip>
        </div>
      </div>
    </template>
    <template v-slot:[`item.phone`]="{ item }">
      <v-tooltip max-width="250px" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
            {{ item | getContactBookPhones }}
          </div>
        </template>
        <span>{{ item | getContactBookPhones }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>
<script>
import { mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

const headers = [
  { text: 'Học sinh', value: 'name', width: '35%' },
  { text: 'Ngày sinh', value: 'dob', width: '15%' },
  { text: 'Lớp', value: 'currentClass', width: '10%' },
  { text: 'Hình thức sử dụng', value: 'senderMethod', width: '20%' },
  { text: 'SĐT đăng ký', value: 'phone', width: '30%' }
]

export default {
  components: { CardStudentName },
  props: {
    isSenderMethodShown: {
      type: Boolean,
      default: true
    }  
  },
  computed: {
    ...mapState('tuitionFeeGroupStudent', ['selectedStudent']),
    headers() {
      if (!this.isSenderMethodShown) return headers.slice(0, 3)
      return headers
    }
  },
  filters: {
    getClassCount(classes) {
      return classes ? classes.length : 0
    },
    getClasses(classes) {
      if (classes && classes.length > 0) {
        return classes.map(c => c.title).join(' ,')
      } else return ''
    },
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    }
  },
  methods: {
    hasMobileToken(item) {
      if (item.contactBook && item.contactBook.isApp && (item.fcmAndroid || item.fcmIos)) {
        let tokens = []
        if (item.fcmAndroid) {
          const androidTokens = item.fcmAndroid.split(';')
          androidTokens.map(token => {
            if (token) tokens.push(token)
          })
        }
        if (item.fcmIos) {
          const iosTokens = item.fcmIos.split(';')
          iosTokens.map(token => {
            if (token) tokens.push(token)
          })
        }

        tokens = [...new Set(tokens)]
        return tokens.length > 0
      }

      return false
    }
  }
}
</script>
